module.exports = __webpack_public_path__ + "img/box.3cad4042.png";